import { Box, BoxProps, convertHexToRGBA, IconButton, Text, TextProps } from '@jfs/ui-new'
import { useNavigation } from '@react-navigation/native'
import React, { useEffect, useRef } from 'react'
import { Dimensions } from 'react-native'
import { Modal } from '../../../../comps/Modal'
import { MerchantTheme } from '../../../../data/models/Config'
import { useLazyApiData, useStores } from '../../../../data/store'
import { pages } from '../../../../utils/constants'
import { MetaDataTags } from '../MetaDataTags'

interface ExtraInfoInputProps {
  bankData: any
  show: boolean
  onDismiss: any
  TYPE: any
  makePayment?: (emiPlan: any) => void
}

export const ExtraInfoInput = ({ bankData, show, onDismiss, TYPE, makePayment }: ExtraInfoInputProps) => {
  const { theme, checkEligibility, mobileNo } = useStores((root) => ({
    theme: root.config.merchantTheme,
    checkEligibility: root.jioPayFinanceHub.checkEligibility,
    mobileNo: root.jioPayFinanceHub.mobileNo,
  }))

  console.log('ga bankData', bankData)
  const navigation = useNavigation()
  const userMetaData = useRef(null)

  const [lazyCheckEligibilityApi, checkEligibilityHandler] = useLazyApiData(checkEligibility)

  const isLargeScreen = Dimensions.get('window').width > 550
  const isFullScreen =
    window.location.href.includes('/pg/loader.html') || window.location.href.includes('/pg/redirectToBank')

  useEffect(() => {
    if (checkEligibilityHandler.state === 'fulfilled') {
      onDismiss()
      if (checkEligibilityHandler.data.planSource === '2') {
        makePayment?.(checkEligibilityHandler.data?.emiPlans?.[0])
      } else {
        navigation.navigate(
          pages.selectEmiPlans as never,
          {
            emiPlans: checkEligibilityHandler.data?.emiPlans,
            bankId: bankData?.bankId,
            bankName: bankData?.bankName,
            metaData: userMetaData.current,
          } as never,
        )
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [checkEligibilityHandler.state])
  if (!show) {
    return null
  }

  return (
    <Modal type={'Bottom'} isFullWidth={true} show={show} onDismiss={onDismiss}>
      <Box {...styles.container(isLargeScreen && !isFullScreen, theme)}>
        <Box {...styles.headerContainer}>
          <Text {...styles.headerTitle(theme)}>{bankData?.bankName}</Text>
          <IconButton id={'CLOSE'} onPress={onDismiss} color={convertHexToRGBA(theme.bodyTextColor, 40) as any} />
        </Box>
        <Box overflowY="scroll" maxHeight={'70vh'}>
          <MetaDataTags
            metadata={bankData?.metadata}
            amount={33}
            onSubmit={(metaData: any) => {
              userMetaData.current = metaData
              lazyCheckEligibilityApi(mobileNo, TYPE, bankData?.bankId, metaData)
            }}
            title={'View EMI Plans'}
            isLoading={checkEligibilityHandler.state === 'pending'}
          />
        </Box>
      </Box>
    </Modal>
  )
}

const styles = {
  container: (isLargeScreen: boolean, theme: typeof MerchantTheme.properties) =>
    ({
      borderTopLeftRadius: 16,
      borderTopRightRadius: 16,
      borderBottomLeftRadius: isLargeScreen ? 16 : undefined,
      borderBottomRightRadius: isLargeScreen ? 16 : undefined,
      backgroundColor: theme.bodyBgColor as any,
      pv: 24,
    } as BoxProps),
  headerContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    mb: 32,
    ph: 24,
  } as BoxProps,
  headerTitle: (theme: typeof MerchantTheme.properties) =>
    ({
      fontSize: 16,
      fontFamily: 'jioType-medium',
      color: theme.bodyTextColor as any,
    } as TextProps),
  title: (theme: typeof MerchantTheme.properties) =>
    ({
      fontSize: 14,
      fontFamily: 'jioType-medium',
      color: convertHexToRGBA(theme.bodyTextColor, 50),
      lineHeight: 20,
    } as TextProps),
}
